<template>
  <view class="radio-modal-slots-demo">
    <cube-checkbox-group-modal
      wx:ref="checkboxModal"
      show-close-icon="{{ true }}"
      options="{{ options }}"
      values="{{ value }}"
    >
      <view class="modal-title" slot="title">标题slot</view>
      <view class="modal-subtitle" slot="subtitle">副标题slot</view>
    </cube-checkbox-group-modal>
    <cube-button bindclick="onTap">checkbox-modal-slots</cube-button>
  </view>
</template>

<script>
  import { createComponent } from '@mpxjs/core'

  createComponent({
    data: {
      confirmBtn: '确认支付方式',
      options: [
        {
          value: '1',
          text: '企业支付'
        },
        {
          value: '2',
          text: '亲友代付'
        },
        {
          value: '3',
          text: '个人支付'
        }
      ],
      value: ['2', '3']
    },
    methods: {
      onTap() {
        this.$refs.checkboxModal.show()
      }
    }
  })
</script>

<style lang="stylus">
.modal-title
  font-size 20px
  font-weight bold
  margin-bottom 10px
.modal-subtitle
  margin-bottom 10px
</style>

<script type="application/json">
  {
    "usingComponents": {
      "cube-checkbox-group-modal": "@mpxjs/mpx-cube-ui/src/components/checkbox-modal/index.mpx",
      "cube-button": "@mpxjs/mpx-cube-ui/src/components/button/index.mpx"
    }
  }
</script>
